module.exports = __webpack_public_path__ + "img/15b)(NH Hotel)Montage von über 280 Zimmer.jpg";